<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6">
              <h3></h3>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
          <div class="row">
            <div class="col-sm-12">
              <div class="card">
                <div class="card-body add-post">
                    <div class="row my-3">
                      <div class="w-full ">
                        <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="me-2">Mostrar:</span>
                          <select 
                            v-model="itemsPerPage" 
                            @change="resetPagination"
                            class="form-select w-auto"
                          >
                            <option :value="10">10</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                          <span class="ms-2">registros</span>
                        </div>
                        <!-- Container para botón y filtros -->
                        <div class="flex justify-between items-center w-full mb-4">
                          <!-- Botón a la izquierda -->
                          <button @click="goToCompanyForm" class="custom-create-btn me-80">
                              <span class="custom-create-btn-text">Crear Compañias</span>
                          </button>
                          <!-- Buscador -->
                          <div class="flex px-4 py-[9px] bg-white rounded-md justify-end gap-2 inline-flex">
                            <select 
                              v-model="selectedStatus" 
                              class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                            >
                              <option value="">Todos los estatus</option>
                              <option value="Activo">Activo</option>
                              <option value="Desactivado">Desactivado</option>
                              <option value="Bloqueado">Bloqueado</option>
                              <option value="Pendiente">Pendiente</option>
                            </select>

                            <!-- Input del buscador -->
                            <input
                              type="text"
                              class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              placeholder="Buscar"
                              v-model="searchQuery"
                            />
                          </div> 
                        </div>  
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                                <tr>
                                <th class="py-3 px-6 text-style-custom text-left">ID</th>
                                <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                <th class="py-3 px-6 text-style-custom text-left">Teléfono</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estado</th>
                                <th class="py-3 px-6 text-style-custom text-left">Propiedades</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estatus</th>              
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr
                                v-for="(company, index) in filteredCargos"
                                :key="index"
                                class="border-b border-gray-200 hover:bg-gray-100"
                                >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.id }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.name }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.phone }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.state}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.properties_count}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  company.status === 'Desactivado'|| company.status === 'Bloqueado'}">{{ company.status}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative" ref="el => menuContainers.push(el)">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                      @click.stop="toggleMenu(company.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none"
                                      >
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"
                                        />
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div 
                                      v-show="menuVisible === company.id" 
                                      :class="{
                                        'absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10': true,
                                        'bottom-full mb-1': index === filteredCargos.length - 1 || index === filteredCargos.length - 2, // Si es el último o antepenúltimo registro, despliega hacia arriba
                                        'top-full mt-1': index < filteredCargos.length - 2 // De lo contrario, despliega hacia abajo
                                      }"
                                    >
                                      <ul class="py-1">
                                        <!-- Ver perfil -->
                                        <li 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="profileCompany(company.id)"
                                        >
                                          Ver Perfil
                                        </li>
                                        <!-- Editar -->
                                        <li 
                                          v-if="company.status !== 'Desactivado' && company.status !== 'Bloqueado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer" 
                                          @click="editCargo(company.id)"
                                        >
                                          Editar
                                        </li>
                                        <!-- Activar -->
                                        <li 
                                          v-if="company.status === 'Desactivado'" 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-green-500" 
                                          @click="confirmActive(company.id)"
                                        >
                                          Activar
                                        </li>
                                        <!-- Desactivar -->
                                        <li 
                                          v-else 
                                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" 
                                          @click="deleteCargo(company.id)"
                                        >
                                          Desactivar
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <DeleteModal
                          v-if="showModal"
                          :visible="showModal"
                          @close="showModal = false"
                          @confirm="confirmDelete"
                        />
                    </div>
                    <div class="flex justify-between items-center w-full">
                      <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div style="display: flex; justify-content: flex-end; align-items: center; padding: 8px 12px;">
                        <button 
                          @click="changePage(currentPage - 1)" 
                          :disabled="currentPage === 1"
                          :style="{padding: '8px 12px', border: '1px solid var(--Primary-Primary,  #FFD8DF)', background: 'var(--Primary-Primary, #FFF)', color: '#FF4265', opacity: page === 1 ? '0.5' : '1',cursor: page === 1 ? 'not-allowed' : 'pointer' }"
                        >
                          &lt;
                        </button>
                        
                        <!-- Números de página -->
                        <div style="display: flex; gap: 0; align-items: center;">
                            <button
                              v-for="pageNumber in totalPages" 
                              :key="pageNumber" @click="changePage(pageNumber)" 
                              :style="{
                                padding: '8px 12px',
                                border: '1px solid var(--Primary-Primary,  #FFD8DF)',
                                background: pageNumber === currentPage ? '#FF4265' : 'var(--Primary-Primary, #FFF)',
                                color: pageNumber === currentPage ? '#FFF' : '#FF4265',
                                fontWeight: pageNumber === currentPage ? 'bold' : 'normal',
                                cursor: 'pointer'
                              }"
                            >
                              {{ pageNumber }}
                            </button>
                          </div>
                        
                        <button 
                          @click="changePage(currentPage + 1)" 
                          :disabled="currentPage === totalPages"
                          class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: 'var(--Primary-Primary, #FFF)',color: '#FF4265',opacity: page >= totalPages ? '0.5' : '1',cursor: page >= totalPages ? 'not-allowed' : 'pointer'
                          }"
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import 'vue-toastification/dist/index.css';
  import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/company/Modal/DeleteCompanyModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const page = ref(1); // Página actual
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const selectedStatus = ref("");
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(10); // Number of items to show per page
  const menuContainers = ref([]); 

  // Métodos
  
  //obtener los cargos
    async function fetchCargos() {
        try {
            let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
            };
            const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/company`, options
            );
            if (response.status === 401) {
            store.dispatch('clearUserSession');
            }
            console.log("Respuesta completa de la API:", response);
            // Accede a los cargos en response.data.cargos
            if (response.status === 200 && response.data?.resp?.companies) {
              company.value = response.data.resp.companies.map(company => ({
                ...company,
                status: translateStatus(company.status), // Traduce el estado de la compañía
              }));
            } else {
              console.error("Error en la respuesta de la API: estructura inesperada");
            }
        } catch (error) {
            console.error("Error al obtener los cargos:", error);
        } finally {
            isLoading.value = false;
        }
    }


    const deleteCargo = (company_id) => {
    selectedCargoId.value = company_id; // Almacena el ID del usuario
    showModal.value = true
  };
  const translateStatus = (status) => {
    const statusTranslations = {
      active: 'Activo',
      disabled: 'Desactivado',
      block: 'Bloqueado',
      pending: 'Pendiente',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
  const profileCompany = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'company-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  };

  async function confirmDelete() {
      try {
        // Configuración de los encabezados
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };

        // Envío de la solicitud con el rol_id
        const data = { company_id: selectedCargoId.value };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-delete`,
          data, 
          options
        );

        // Manejo de la respuesta
        if (response.status === 200) {
          showModal.value = false
          console.log("Cargo eliminado correctamente:", response.data.message);
          fetchCargos();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error(
          "Error al intentar eliminar el cargo:",
          error.response?.data?.message || error.message
        );
      }
    }
    const confirmActive = async (company_id) => {
      selectedCargoId.value = company_id; // Almacena el ID del usuario
      try {
        let options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`,
            'Content-Type': 'application/json',
          },
        };
        const data = { company_id: selectedCargoId.value };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-active`, 
          data, 
          options
        );

        if (response.status === 200) {
          showModal.value = false
          console.log("Cuenta eliminado correctamente:", response.data.message);
          fetchCargos();
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          return response.data.message; 
        }
      } catch (error) {
        console.error('Error al activar el usuario', error);
      }
    };
    const goToCompanyForm = () => {
      router.push({ name: 'company-form' });
    };
    const editCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'company-form-edit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };
    const resetPagination = () => {
      page.value = 1; // Reset to first page
    };
    const filteredCargos = computed(() => {
        // Verify if company.value is a valid array
        if (!Array.isArray(company.value)) return [];

        // Filter by search query and status
        let filtered = company.value;

        // Filter by search query
        if (searchQuery.value) {
            filtered = filtered.filter(compani => {
                // Iterate over all properties of 'compani' and check if any contains the search query
                return Object.values(compani).some(value => 
                    value && typeof value === 'string' && value.toLowerCase().includes(searchQuery.value.toLowerCase())
                );
            });
        }

        // Filter by status
        if (selectedStatus.value) {
            filtered = filtered.filter(compani => 
                compani.status === selectedStatus.value
            );
        }

        // Paginate the filtered results
        const start = (currentPage.value - 1) * itemsPerPage.value;
        const end = start + itemsPerPage.value;

        return filtered.slice(start, end);
    });

    const totalPages = computed(() => {
        let filtered = !searchQuery.value
            ? company.value
            : company.value.filter(compani => {
                // Iterate over all properties of 'compani' and check if any contains the search query
                return Object.values(compani).some(value =>
                    value && typeof value === 'string' && value.toLowerCase().includes(searchQuery.value.toLowerCase())
                );
            });

        return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
     // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  fetchCargos();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
  </script>
  
  <style scoped>
    .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 8px;
    }
  </style>